const messages = require('../../utils/constants');

function globalAuthParseEncryptionKey(encryptionKey) {
  if (encryptionKey != null && encryptionKey.returnCode != null) {
    if (encryptionKey.returnCode === 0) {
      return {
        modulus: encryptionKey.modulus,
        exponent: encryptionKey.exponent,
        token: encryptionKey.token,
        returnCode: encryptionKey.returnCode,
        seskey: encryptionKey.seskey,
        pwdModeCur: encryptionKey.pwdModeCur,
        pwdModeNew: encryptionKey.pwdModeNew,
        randnr: encryptionKey.randnr,
        pubkey: encryptionKey.pubkey,
        keyType: encryptionKey.keyType,
        encryptionMSG: ""
      };
    } else {
      return {
        returnCode: encryptionKey.returnCode,
        encryptionMSG: messages[encryptionKey.returnCode] == null ? messages['1003'] : messages[encryptionKey.returnCode]
      };
    };

  } else {
    return {
      returnCode: -1,
      encryptionMSG: messages["error-encryption-phonline"]
    };
  }
}

function parseAuthentication(auth) {
  if (auth != null && auth.ret != null) {
    if (auth.ret === 0) {
      return {
        authSuccess: auth.ret === 0,
        authHeader: auth.jwt,
        sessionId: auth.seskey,
        passwordExpired: null != auth.indchp ? auth.indchp != "0" : false,
        lastSession: auth.lastSession,
        strLastSession: auth.strLastSession ? auth.strLastSession : '',
        userGroup: auth.userGroup,
        message: "",
        sessionActive: auth.sessionActive ? auth.sessionActive : false,
        language: auth.lng,
        eCredPin: auth.eCredPin,
        eCredPwd: auth.eCredPwd,
        tempLockTimeOut: auth.tempLockTimeOut,
        isPinMailerEngaged: auth.isPinMailerEngaged ? auth.isPinMailerEngaged : false,
        e2eCryptoObj: auth.e2eCrypto ? auth.e2eCrypto : null
      };
    } else if (auth.ret === 1072) {
      return {
        returnCode: auth.ret,
        authSuccess: false,
        tempLockTimeOut: auth.tempLockTimeOut
      }
    }
    else {
      return {
        returnCode: auth.ret,
        authSuccess: false,
        message: messages[auth.ret] == null ? messages['1003'] : messages[auth.ret]
      }
    }
  } else {
    return {
      authSuccess: false,
      message: messages["invalid-access"]
    };
  }
}

function parseAuthenticationAirlock(auth) {
  if (auth != null && auth.ret != null) {
    if (auth.ret === 0) {
      return {
        authSuccess: auth.ret === 0,
        // authHeader: auth.jwt,  // WMCE-48470 - not adding authHeader because we dont need JWT to be passed in settings screens once authenticate is called 
        sessionId: auth.seskey,
        passwordExpired: null != auth.indchp ? auth.indchp != "0" : false,
        lastSession: auth.lastSession,
        strLastSession: auth.strLastSession ? auth.strLastSession : '',
        userGroup: auth.userGroup,
        message: "",
        sessionActive: auth.sessionActive ? auth.sessionActive : false,
        language: auth.lng,
        eCredPin: auth.eCredPin,
        eCredPwd: auth.eCredPwd,
        tempLockTimeOut: auth.tempLockTimeOut,
        isPinMailerEngaged: auth.isPinMailerEngaged ? auth.isPinMailerEngaged : false,
        e2eCryptoObj: auth.e2eCrypto ? auth.e2eCrypto : null
      };
    } else if (auth.ret === 1072) {
      return {
        returnCode: auth.ret,
        authSuccess: false,
        tempLockTimeOut: auth.tempLockTimeOut
      }
    }
    else {
      return {
        returnCode: auth.ret,
        authSuccess: false,
        message: messages[auth.ret] == null ? messages['1003'] : messages[auth.ret]
      }
    }
  } else {
    return {
      authSuccess: false,
      message: messages["invalid-access"]
    };
  }
}

function parseChangePassword(auth) {
  if (auth != null && auth.returnCode != null) {
    const oStatus = auth.returnCode != null ? auth.returnCode === 0 : false;
    const oMessage = oStatus ? '' : messages[auth.returnCode] == null ? messages['error-pwd-update'] : messages[auth.returnCode];
    return {
      returnCode: auth.returnCode,
      changePasswordSuccess: oStatus,
      message: oMessage
    };
  } else {
    return {
      changePasswordSuccess: false,
      message: messages["invalid-access"]
    };
  }
}

function parseAuthorizeWebSSOUser(result) {
  if (result != null) {
    return JSON.stringify(result);
  } else {
    return {
      authorizeWebSSOUserSuccess: false,
      message: messages["invalid-access"]
    };
  }
}

function parseInitiateResetPin(response) {
  if ((!response) || response.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(response);
  }
}

function parseGenerateAuthCodeForECred(response) {
  if ((!response) || response.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(response);
  }
}

function parseValidateECredAuthCode(response) {
  if ((!response) || response.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(response);
  }
}

function parseUpdateECredStatus(response) {
  if ((!response) || response.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(response);
  }
}

function parseInitiateResetPassword(response) {
  if ((!response) || response.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(response);
  }
}

function parseGenerateTempPassword(response) {
  if ((!response) || response.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(response);
  }
}

function parseLogout(logout) {
  return {
    logoutSuccess: logout.ret == '0'
  };
}

function serviceFactory({ api }) {
  const getGlobalAuthEncryptionKey = ({ userId, type, metaData }) =>
    api.getGlobalAuthEncryptionKey(userId, type, metaData).then(globalAuthParseEncryptionKey);

  const getGlobalAuthEncryptionKeyForLUX = ({ inputParam, metaData }) =>
    api.getGlobalAuthEncryptionKeyForLUX(inputParam, metaData).then(globalAuthParseEncryptionKey);


  const getGlobalAuthentication = ({ userId, password, dummySesKey, token, cryptoPass, deviceInfo, regionCode }) => {
    return api
      .getGlobalAuthentication(userId, password.slice(10), dummySesKey.slice(12), token.slice(6), cryptoPass.slice(11), deviceInfo.slice(4), regionCode)
      .then(parseAuthentication)
      .catch(parseAuthentication);
  }

  const getGlobalAuthenticationAirlock = ({ userId, password, dummySesKey, token, cryptoPass, deviceInfo, regionCode }) => {
    return api
      .getGlobalAuthentication(userId, password.slice(10), dummySesKey.slice(12), token.slice(6), cryptoPass.slice(11), deviceInfo.slice(4), regionCode)
      .then(parseAuthenticationAirlock)
      .catch(parseAuthenticationAirlock);
  }


  const getGlobalAuthenticationForLUX = ({ inputParam, metaData }) => {
    return api
      .getGlobalAuthenticationForLUX(inputParam, metaData)
      .then(parseAuthentication)
      .catch(parseAuthentication);
  }

  const globalAuthChangeProfilePassword = ({ userId, encryptedPassword, oldEncryptedPassword, oldCryptoPassword, newCryptoPassword, token, dummySesKey, regionCode, metaData }) =>
    api.globalAuthChangeProfilePassword(userId, encryptedPassword.slice(18), oldEncryptedPassword.slice(21), oldCryptoPassword.slice(18), newCryptoPassword.slice(18), token.slice(6), dummySesKey.slice(12), regionCode, metaData)
      .then(parseChangePassword)
      .catch(parseChangePassword);

  const globalAuthChangeProfilePasswordForLux = ({ userId, encryptedPassword, oldEncryptedPassword, oldCryptoPassword, newCryptoPassword, token, dummySesKey, regionCode, metaData }) =>
    api.globalAuthChangeProfilePasswordForLux(userId, encryptedPassword.slice(18), oldEncryptedPassword.slice(21), oldCryptoPassword.slice(18), newCryptoPassword.slice(18), token.slice(6), dummySesKey.slice(12), regionCode, metaData)
      .then(parseChangePassword)
      .catch(parseChangePassword);

  const initiateResetPin = ({ inputParam, metaData }) =>
    api
      .initiateResetPin(inputParam, metaData)
      .then(parseInitiateResetPin)
      .catch(parseInitiateResetPin);

  const generateAuthCodeForECred = ({ inputParam, metaData }) =>
    api
      .generateAuthCodeForECred(inputParam, metaData)
      .then(parseGenerateAuthCodeForECred)
      .catch(parseGenerateAuthCodeForECred);

  const validateECredAuthCode = ({ inputParam, metaData }) =>
    api
      .validateECredAuthCode(inputParam, metaData)
      .then(parseValidateECredAuthCode)
      .catch(parseValidateECredAuthCode);

  const updateECredStatus = ({ inputParam, metaData }) =>
    api
      .updateECredStatus(inputParam, metaData)
      .then(parseUpdateECredStatus)
      .catch(parseUpdateECredStatus);

  const initiateResetPassword = ({ inputParam, metaData }) =>
    api
      .initiateResetPassword(inputParam, metaData)
      .then(parseInitiateResetPassword)
      .catch(parseInitiateResetPassword);

  const generateTempPassword = ({ inputParam, metaData }) =>
    api
      .generateTempPassword(inputParam, metaData)
      .then(parseGenerateTempPassword)
      .catch(parseGenerateTempPassword);

  const logout = ({ metaData, channelInfo, logoutDsc }) =>
    api.logout(metaData, channelInfo, logoutDsc).then(parseLogout);

  const updatePassword = ({ inputParam, metaData }) =>
    api.updatePassword(inputParam, metaData)
      .then(parseChangePassword)
      .catch(parseChangePassword);

  const initiateChangePassword = ({ inputParam, metaData }) =>
        api.initiateChangePassword(inputParam, metaData)
          .then(parseInitiateResetPassword)
          .catch(parseInitiateResetPassword);

  return {
    getGlobalAuthEncryptionKey,
    getGlobalAuthentication,
    getGlobalAuthenticationAirlock,
    globalAuthChangeProfilePassword,
    initiateResetPin,
    generateAuthCodeForECred,
    validateECredAuthCode,
    updateECredStatus,
    initiateResetPassword,
    generateTempPassword,
    getGlobalAuthenticationForLUX,
    getGlobalAuthEncryptionKeyForLUX,
    globalAuthChangeProfilePasswordForLux,
    logout,
    updatePassword,
    initiateChangePassword
  };
}

module.exports = serviceFactory;
